import * as Oazapfts from "oazapfts/lib/runtime";

// TODO: Re-enable once API Gateway and database connection issues are resolved
// import { errorRoutes, routes } from "routes";

const getBaseUrl = (): string => {
	let base = process.env.REACT_APP_API_URL || "http://localhost:8081";
	if (base[base.length - 1] === "/") {
		base = base.substring(0, base.length - 1);
	}
	// if (base !== "http://localhost:8081") {
	// 	return `${base}`;
	// }
	return `${base}/api/v1/`;
};

const stripLeadingSlash = (path: string): string => {
	if (path[0] === "/") {
		return path.substring(1);
	}
	return path;
};

export const getTestUrl = (path: string): string => {
	return `${getBaseUrl()}${stripLeadingSlash(path)}`;
};

export const getPreviewUrl = (questId: number): string => {
	return `${process.env
		.REACT_APP_PREVIEW_URL!}questions/${questId.toString()}/images/banner.png`;
};

const customFetch = (...args: Parameters<typeof fetch>): Promise<Response> =>
	fetch(...args).then((res) => {

        // TODO: Re-enable once API Gateway and database connection issues are resolved
		// if (res.status === 401) {
		// 	window.location.href = routes._.signIn.path;
		// 	throw new Error("Unauthorized");
		// }
		// if (res.status === 404 || res.status === 500) {
		// 	window.location.href = errorRoutes._.error.path;
		// }
		// if (res.status === 403) {
		// 	window.location.href = errorRoutes._.forbidden.path;
		// }
		// if (res.status >= 500) {
        //     window.location.href = errorRoutes._.error.path;
		// }

		return res;
	});

export const wrapper = Oazapfts.runtime({
	baseUrl: getBaseUrl(),
	credentials: "include",
	fetch: customFetch,
});

export const authStatusWrapper = Oazapfts.runtime({
	baseUrl: getBaseUrl(),
	credentials: "include",
});

export const DateAsYYYYMMDDHHMMSS = (date: Date): string => {
	return (
		date.getFullYear().toString() +
		(date.getMonth() + 1).toString().padStart(2, "0") +
		date.getDate().toString().padStart(2, "0") +
		date.getHours().toString().padStart(2, "0") +
		date.getMinutes().toString().padStart(2, "0") +
		date.getSeconds().toString().padStart(2, "0")
	);
};

export const DateAsYYYY_MM_DD = (date: Date): string => {
	return (
		date.getFullYear().toString() +
		"-" +
		(date.getMonth() + 1).toString().padStart(2, "0") +
		"-" +
		date.getDate().toString().padStart(2, "0")
	);
};
